import * as React from 'react'

// Components
import Svg from './..'

const Chevron = props => {
  return (
    <Svg fill='none' height='13' viewBox='0 0 26 13' width='26' {...props}>
      <path
        clipRule='evenodd'
        d='m1 1 12.1212 10 11.5152-10'
        stroke='#41b9fa'
        strokeWidth='2'
      />
    </Svg>
  )
}

export default Chevron
